interface IREVERSE_GST_FORMULA {
  amount: number;
  gstRate: string;
  isStateGoods: string;
}
export const REVERSE_GST_FORMULA = ({
  amount,
  gstRate,
  isStateGoods,
}: IREVERSE_GST_FORMULA) => {
  const amt = Number(amount);
  const gstRateNumber = Number(gstRate) / 100;
  const amtExGst = amt / (1 + gstRateNumber);
  const totGST = amt - amtExGst;

  const cGST = isStateGoods === 'NO' ? 0 : totGST / 2;
  const sGST = isStateGoods === 'NO' ? 0 : totGST / 2;
  const iGST = isStateGoods === 'NO' ? totGST : 0;

  return {
    amtOutput: amtExGst.toFixed(2),
    CGST: cGST.toFixed(2),
    SGST: sGST.toFixed(2),
    totalGST: totGST.toFixed(2),
    IGST: iGST.toFixed(2),
  };
};
